/* eslint-disable @typescript-eslint/no-explicit-any */
type HasProperty<T, K extends keyof any> = K extends keyof T ? T : never;

const hasProperty = <T extends object, K extends keyof any>(
    obj: T,
    key: K,
): obj is T & Record<K, unknown> => {
    return key in obj;
};

export { hasProperty };
export type { HasProperty };
